export enum ExplainabilityRelevantSkillSourceEnum {
  TalentProfile = 'TALENT_PROFILE',
  Inferred = 'INFERRED',
}
